import React, { useState } from "react";
import NameSelector from "./NameSelector";
import SelectPart from "./SelectPart";
import SelectSymptom from "./SelectSymptom";
import "../styles/HealthReport.css";

const HealthReport = () => {
  const [selectedName, setSelectedName] = useState(""); // 名前の状態
  const [selectedPart, setSelectedPart] = useState("");
  const [selectedSymptom, setSelectedSymptom] = useState("");
  const [freeText, setFreeText] = useState(""); // 自由入力の状態

  const handleSubmit = () => {
    if ((selectedPart || freeText) && selectedName) {
      const report = {
        name: selectedName,
        part: selectedPart || "自由入力",
        symptom: selectedSymptom || "自由入力",
        details: freeText,
        date: new Date(),
      };
      console.log("送信データ:", report);
      alert(`報告が送信されました！\n名前: ${report.name}`);
    } else {
      alert("名前と少なくとも1つの項目を入力してください！");
    }
  };

  return (
    <div className="health-report">
      <h1>体調不良の報告</h1>
      <NameSelector selectedName={selectedName} setSelectedName={setSelectedName} />
      <SelectPart selectedPart={selectedPart} setSelectedPart={setSelectedPart} />
      {selectedPart && (
        <SelectSymptom selectedPart={selectedPart} setSelectedSymptom={setSelectedSymptom} />
      )}
      <div className="free-text-input">
        <label htmlFor="free-text">自由入力:</label>
        <textarea
          id="free-text"
          placeholder="詳しい症状や状況を記入してください"
          value={freeText}
          onChange={(e) => setFreeText(e.target.value)}
          rows="4"
          cols="50"
        />
      </div>
      <button onClick={handleSubmit} className="submit-button">
        送信
      </button>
    </div>
  );
};

export default HealthReport;
